export class ProjectCategory {

    constructor(projectCategoryId:string = "", name:string = "", description:string = "") {
        this.ProjectCategoryId = projectCategoryId;
        this.Name = name;
        this.Description = description;
    }
    
    public ProjectCategoryId: string;
    public Name: string;
    public Description: string;

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/project-category.ts